



import { getSystem, resetPageUrl } from './index.js';
// import LbNative from './LbNative';
//info {url 跳转地址  params 跳转参数  login 是否需要登录态} showTab 是否显示头部 jumpType 跳转方式

window.locationTo = ({ url='', params={}, login=true, showTab=true, jumpType='na'}) => {
  //当跳转项目内时，修正url
  if(typeof(url)=='string'&& url.indexOf('//') < 0) {
        url = resetPageUrl(url, params);
    }
  //app内
  if(getSystem().isJr) {
    if(jumpType === 'na') jumpToNa(url, login, showTab);
    else if(jumpType === 'href') jumpToHref(url);
    else if(jumpType === 'replace') jumpToReplace(url);
  }
  //app外 
  else {
    if(jumpType === 'href') jumpToHref(url);
    else if(jumpType === 'replace') jumpToReplace(url);
    else jumpToHref(url);
  }
}

function jumpToNa(url, login, showTab) {
  if(url === -1) {
    //LbNative.close();
  }else if(url.indexOf('yocial://')===0) {
    //LbNative.nativepage({"routeUrl": url});
  }else {
    let routeUrl = `yocial://webview?url=${encodeURIComponent(url)}`;
    if(url.indexOf('jd.com')<0) login = false;
    //需要登录态
    if(login) routeUrl = `${routeUrl}&login=1`;
    //需要隐藏头部
    if(!showTab) routeUrl = `${routeUrl}&hideTab=1`;
    window.JrBridge.openView({
      target: url,
      container: 'h5',
      islogin: true,
      isClose: false
  })
    //LbNative.nativepage({"routeUrl": routeUrl});
  }
}

function jumpToHref(url) {
  if(url === -1) {
    window.history.back(-1);
  }else {
    window.location.href = url;
  }
}
function jumpToReplace(url) {
  if(url === -1) {
    window.history.back(-1);
  }else {
    window.location.replace(url)
  }
}



Date.prototype.format = function(format) {
    var o = {
        "M+": this.getMonth() + 1,
        "d+": this.getDate(),
        "h+": this.getHours(),
        "m+": this.getMinutes(),
        "s+": this.getSeconds(),
        "q+": Math.floor((this.getMonth() + 3) / 3),
        "S": this.getMilliseconds()
    }
    if (/(y+)/.test(format)) {
        format = format.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
    }
    for (var k in o) {
        if (new RegExp("(" + k + ")").test(format)) {
            format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
        }
    }
    return format;
}